<template>
  <div ref="empty" :class="bem.b()" :style="style">
    <slot name="image">
      <img
        :style="{ width: imageWidth }"
        :src="url || defaultEmptyUrl"
        draggable="false"
      />
    </slot>
    <div :class="bemInner.b()">
      <slot v-if="showTitle" name="title">
        <div :class="bemTitle.b()" v-html="purifiedTitleHtml"></div>
      </slot>
    </div>
    <div :class="bem.e('operate-content')">
      <slot name="operate" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed, nextTick, onMounted, ref } from 'vue'

import { addUnit, createNamespace } from '@ll-plus/utils'
import DOMPurify from 'dompurify'
import { defaultEmptyUrl, emptyProps } from './empty'

// 1.defineOptions
defineOptions({ name: 'LlEmpty' })

// 2.props
const props = defineProps(emptyProps)

// 3.computes/const

const empty = ref<HTMLElement>()
const purifiedTitleHtml = computed(() => {
  return DOMPurify.sanitize(props.title || '')
})
// 计算宽度
const style = computed(() => {
  return {
    width: addUnit(props.width),
    height: addUnit(props.height),
  }
})
// 计算图片宽度
const imageWidth = computed(() => addUnit(props.imageWidth))
const bem = createNamespace('empty')
const bemInner = createNamespace('empty-inner')
const bemTitle = createNamespace('empty-title')
// 禁止选中函数
const disableSelection = (element: HTMLElement) => {
  element.style.userSelect = 'none'
  element.style.webkitUserSelect = 'none'
  // element.style.msUserSelect = 'none'
  // element.style.mozUserSelect = 'none'
  element.onselectstart = () => false
  element.onmousedown = () => false
}

onMounted(async () => {
  await nextTick()
  if (empty.value) {
    // @ts-ignore
    disableSelection(empty.value)
  }
})
</script>
